import React from 'react';

/** Halo lavanda difuso. Puramente decorativo. */
export function Halo({
  className = '',
  soft = false
}: {
  className?: string;
  soft?: boolean;
}) {
  return <div aria-hidden="true" className={`pointer-events-none absolute rounded-full blur-2xl ${soft ? 'halo-soft' : 'halo'} ${className}`} data-id="element-3" data-mp="et89jscyvhgn" />;
}

/** Línea editorial fina con punto, para separar bloques sin usar bordes duros. */
export function RuleDot({
  className = ''
}: {
  className?: string;
}) {
  return <span aria-hidden="true" className={`inline-flex items-center gap-2 ${className}`} data-id="element-4" data-mp="3s7bl8ht0vtjb">
      <span className="h-px w-10 bg-lavender-300" data-id="element-5" data-mp="yxopm43c7fv" />
      <span className="h-1.5 w-1.5 rounded-full bg-orchid" data-id="element-6" data-mp="5qp739d3f6ux" />
    </span>;
}

/** Sello circular de marca: CONSTRUIR · POSICIONAR · CRECER */
export function BrandSeal({
  className = ''
}: {
  className?: string;
}) {
  return <div aria-hidden="true" className={`pointer-events-none select-none ${className}`} data-id="element-7" data-mp="39f8xynlvlf03">
      <div className="relative flex h-full w-full items-center justify-center rounded-full border border-lavender-200 bg-ivory/85 backdrop-blur-[2px]" data-id="element-8" data-mp="2aijcqkabavqb">
        <svg viewBox="0 0 100 100" className="spin-slow absolute inset-0 h-full w-full" data-id="element-9" data-mp="25l9pnbaeaw5n">
          <defs data-id="element-10" data-mp="20qnb4z90onhc">
            <path id="inkova-seal-path" d="M50,50 m-37,0 a37,37 0 1,1 74,0 a37,37 0 1,1 -74,0" fill="none" data-id="element-11" data-mp="20q3wbrenyf7j" />
          </defs>
          <text fill="#5A4579" fontSize="8.2" letterSpacing="2.1" fontFamily="Inter, system-ui, sans-serif" data-id="element-12" data-mp="1rt3cly2jh5af">
            <textPath href="#inkova-seal-path" startOffset="0" data-id="element-13" data-mp="1hunhzl4azdw6">
              CONSTRUIR · POSICIONAR · CRECER ·
            </textPath>
          </text>
        </svg>
        <span className="h-2 w-2 rounded-full bg-orchid" data-id="element-14" data-mp="3c7de89i58z6q" />
      </div>
    </div>;
}